/**
 * Names the shell shows in more than one place: the desktop nav, the phone
 * tabs, More and each admin page's title. Sentence case, so a tool reads the
 * same wherever it appears.
 */
export const SECTION_NAMES = {
  calendar: "Calendar",
  chat: "Chat",
  movements: "Movements",
  details: "Team details",
} as const;

export const TOOL_NAMES = {
  blocks: "Blocks",
  openSeason: "Open season",
  curatedRooms: "Curated rooms",
  homeShelves: "Home shelves",
  remoteConfig: "Remote config",
  ladderLinks: "Ladder links",
  promos: "Promo codes",
  partnerships: "Partnerships",
  badges: "Badges",
  members: "Members",
} as const;

export const SHELL_NAMES = {
  more: "More",
  searchMembers: "Search members",
  welcomeWorkout: "Welcome workout",
  welcomeVideo: "Welcome video",
} as const;

/** The build's version as every surface prints it: "v6.03". */
export const versionLabel = (version: string) => `v${version}`;
